export default {
  dataEditStaff: state => state.dataEditStaff,
}
